<template>
    <div>
        <uiv-alert type="info">
            {{ switchPlan.supplierName }} will carry out a credit check to help them make a decision about the tariffs
            and services they can offer you. {{ switchPlan.supplierName }} use a credit reference
            agency for the check and there'll be a record left of this search. {{ switchPlan.supplierName }} will also
            provide updates to their credit reference agency about how and when you pay.
        </uiv-alert>

        <div class="form-group _margin-bottom-30">
            <div class="col-xs-12 _margin-bottom-20">
                <form-label id="switchAfterCoolingOfPeriod">Faster Switching</form-label><br />
                <small>Select one:</small>
                <radio :value="false" id="asap" v-model="terms.switchAfterCoolingOfPeriod"
                       :error="v.switchAfterCoolingOfPeriod.$error">
                    I want to switch to {{ switchPlan.supplierName }} as soon as possible and consent to being billed
                    for the services provided after my switch has been processed and pay for any usage of energy
                    consumed should I change my mind during the 14 day *cooling off period.
                </radio>

                <radio :value="true" id="14days" v-model="terms.switchAfterCoolingOfPeriod"
                       :error="v.switchAfterCoolingOfPeriod.$error">
                    Please delay my switch by two weeks until after the 14 day *cooling-off period is over.
                </radio>
            </div>

            <div class="col-xs-12 _margin-bottom-20">
                <small>
                    *The cooling-off period commences the day after you enter a contract with {{
                    switchPlan.supplierName
                    }} for your new energy supply. The cooling off period will last for 14 days.
                    {{ switchPlan.supplierName }} will inform you when your new supply for energy will start upon
                    processing this switch
                </small>
            </div>
        </div>

        <div class="form-group _margin-bottom-20" v-show="switchPlan.payMethod == 'PrePaymentMeter'">
            <div class="col-sm-8">
                <form-label id="prePaymentMeter">Pre Payment Meter Type</form-label>
                <validation-messages label="Pre Payment Meter Type" :$v="v.prePaymentMeterId">
                    <select-list id="prePaymentMeter" v-model="terms.prePaymentMeterId" value-key="id"
                                 :list="prepaymentList" :error="v.prePaymentMeterId.$error" />
                </validation-messages>
            </div>
        </div>

        <uiv-alert type="info">
            EDF Energy Customers Ltd will provide all communications where possible to you electronically.
            If you'd prefer paper communications you are able to change your preferences later, with EDF Energy
            Customers Ltd.
        </uiv-alert>

        <div class="form-group _margin-bottom-20">
            <div class="col-sm-12">
                <checkbox id="hasMedicalCondition" v-model="terms.hasMedicalConditionOrIndividualRequirement"
                          @change="onChangeSpecialNeeds">
                    I have a particular medical condition or individual requirement.<br />
                    <small v-if="terms.hasMedicalConditionOrIndividualRequirement">
                        Any information provided will be
                        passed onto your new Supplier, who may subsequently request further information from
                        you.
                    </small>
                </checkbox>
            </div>

            <div class="col-sm-8 _margin-top-20" v-if="terms.hasMedicalConditionOrIndividualRequirement">
                <form-label id="condition">Conditions</form-label>
                <validation-messages label="Condition" :$v="v.specialNeedsId">
                    <select-list id="condition" v-model="terms.specialNeedsId" value-key="id" :list="specialNeedsList"
                                 :error="v.specialNeedsId.$error" />
                </validation-messages>
            </div>
        </div>

        <uiv-alert type="info" v-if="terms.hasMedicalConditionOrIndividualRequirement">
            If you have selected that you have a particular medical condition or requirement, with your consent {{
                switchPlan.supplierName
            }} will share some of your information
            with the company responsible for getting the energy to your house. You'll get extra support from them when
            you need it,
            such as when there is a planned Gas/Electricity outage.
        </uiv-alert>

        <div class="form-group _margin-bottom-20">
            <div class="col-md-10">
                <validation-messages label="Terms & Conditions Agreement"
                                     :$v="v.suppliersTermsAndConditionsAreAccepted">
                    <checkbox id="termsAndConditions" v-model="terms.suppliersTermsAndConditionsAreAccepted"
                              :error="v.suppliersTermsAndConditionsAreAccepted.$error"
                              @change="terms.suppliersTermsAndConditionsAreAccepted = terms.suppliersTermsAndConditionsAreAccepted ? true : null">
                        Yes, I accept the energy supplier <a target="_blank" :href="switchPlan.supplierTosUrl">
                            terms and
                            conditions
                        </a>
                    </checkbox>
                </validation-messages>
            </div>
        </div>
    </div>
</template>

<script>
    import RadioButton from '../forms/RadioButton';
    import { mapState } from 'vuex';

    export default {
        name: 'Edf',
        props: {
            v: Object
        },
        mounted() {
            this.terms.happyToReceiveCreditCheck = true;
        },
        computed: {
            ...mapState({
                switchPlan: ({ personal_details_switch_plan }) => personal_details_switch_plan,
                terms: ({ personal_details_terms }) => personal_details_terms,
                specialNeedsList: ({ lookups }) => lookups.specialNeeds,
                prepaymentList: ({ lookups }) => lookups.prepayments
            })
        },
        methods: {
            onChangeSpecialNeeds() {
                if (this.terms.hasMedicalConditionOrIndividualRequirement) {
                    this.$store.dispatch('lookups/getSpecialNeedsList');
                } else {
                    this.terms.specialNeedsId = null;
                }
            },
            onChangeSmartMeterInstalled() {
                if (this.terms.gasSmartMeterInstalled || this.terms.electricitySmartMeterInstalled) {
                    this.terms.agreeSmartMeterConditions = null;
                    this.terms.neitherSmartMeterInstalled = false;
                } else {
                    this.terms.agreeSmartMeterConditions = false;
                    this.terms.neitherSmartMeterInstalled = null;
                }
            },
            onChangeNeitherInstalled(value) {
                this.terms.neitherSmartMeterInstalled = value || null;
                this.terms.gasSmartMeterInstalled = false;
                this.terms.electricitySmartMeterInstalled = false;
                this.terms.agreeSmartMeterConditions = false;
            }
        },
        components: {
            RadioButton
        }
    };
</script>

<style lang="scss"></style>
